import { fieldIsRequired } from 'shared/utils/tools'
import { LOCALIZATION_CANADA, LOCALIZATION_USA } from 'shared/constants/organizationSetting'
import canadaProvinces from 'shared/constants/canadaProvinces'
import usStates from 'shared/constants/usStates'
import * as yup from 'yup'

export const addressSchema = yup.object().shape({
  address: yup.string(),
  street_address: yup.string().required(fieldIsRequired),
  city: yup.string().required(fieldIsRequired),
  state: yup.string().required(fieldIsRequired),
  postal_code: yup.string().required(fieldIsRequired),
  unit: yup.string(),
})

export const nullableAddressSchema = yup.object().shape({
  address: yup.string(),
  street_address: yup.string().nullable(),
  city: yup.string().nullable(),
  state: yup.string().nullable(),
  postal_code: yup.string().nullable(),
  unit: yup.string(),
})

export type AddressType = yup.InferType<typeof addressSchema>
export type NullableAddressType = yup.InferType<typeof nullableAddressSchema>

export function getEmptyAddress(localization = ''): AddressType {
  let addressObj = {
    address: '',
    street_address: '',
    city: '',
    state: '',
    postal_code: '',
    unit: '',
  }

  if (localization == LOCALIZATION_CANADA) {
    addressObj.state = canadaProvinces[0].value
  } else if (localization == LOCALIZATION_CANADA) {
    addressObj.state = usStates[0].value
  }
  return addressObj
}

export function getEmptyNullableAddress(): NullableAddressType {
  return {
    address: '',
    street_address: '',
    city: '',
    state: '',
    postal_code: '',
    unit: '',
  }
}
